import { IconUserCancel } from '@tabler/icons-react';
import React from 'react';
import { BasicButton } from 'src/design/atoms/BasicButton';
import { Center } from 'src/design/atoms/Center';
import { SimpleGrid } from 'src/design/atoms/SimpleGrid';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { Title } from 'src/design/atoms/Title';

export interface IAccountUnavailableProps {
  message: string;
  onSignOut: () => void;
}

/** @registry Full-page panel for a signed-in account the API refuses at startup (e.g. archived): shows the server's reason and a Sign out action instead of bouncing back through login. */
export const AccountUnavailable: React.FC<IAccountUnavailableProps> = ({
  message,
  onSignOut,
}) => (
  <SimpleGrid cols={1} mt="xl">
    <Center p="xl">
      <Stack align="center" gap="md">
        <IconUserCancel size={54} color="var(--mantine-color-gray-6)" />
        <Title order={3}>Account Unavailable</Title>
        <Text ta="center">{message}</Text>
        <Text ta="center" c="dimmed">
          Contact your administrator if you need access.
        </Text>
        <BasicButton onClick={onSignOut}>Sign out</BasicButton>
      </Stack>
    </Center>
  </SimpleGrid>
);
